"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _validate = require("@/utils/validate");
var _selectCompay = _interopRequireDefault(require("../../../business/supplier/coupons/selectCompay.vue"));
var _mealItem = _interopRequireDefault(require("./mealItem.vue"));
var mealListApi = _interopRequireWildcard(require("@/api/mealListApi.js"));
var specialtyApi = _interopRequireWildcard(require("@/api/specialtyApi.js"));
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    SelectCompay: _selectCompay.default,
    MealItem: _mealItem.default
  },
  data: function data() {
    return {
      ruleForm: {},
      loading: false,
      details: {},
      mealImg: ''
    };
  },
  mounted: function mounted() {
    var id = this.$route.params.id;
    if (id && id != 0) {
      this.getSpecDetail(id);
      return;
    }
    ;
    this.ruleForm = {};
  },
  methods: {
    // 提交保存
    handerSubmit: (0, _validate.Debounce)(function (form) {
      var _this = this;
      var mList = this.$refs['MealItemRef'].getMealVal() || [];
      var meatLists = mList.length && mList.map(function (item) {
        var _ref = item || {},
          selectNum = _ref.selectNum,
          comboName = _ref.comboName,
          _ref$selectProduct = _ref.selectProduct,
          selectProduct = _ref$selectProduct === void 0 ? [] : _ref$selectProduct,
          id = _ref.id,
          sort = _ref.sort,
          image = _ref.image;
        return {
          id: id,
          sort: sort,
          image: image,
          max: selectNum,
          comboName: comboName,
          skuList: selectProduct
        };
      }) || [];
      meatLists = meatLists.length && meatLists.filter(function (item) {
        var _ref2 = item || {},
          max = _ref2.max,
          comboName = _ref2.comboName,
          _ref2$skuList = _ref2.skuList,
          skuList = _ref2$skuList === void 0 ? [] : _ref2$skuList;
        // 这里max=0也可以提交
        return comboName && skuList.length;
      }) || [];
      // if(!meatLists.length) {
      // 	this.$message.warning('请至少配置一项完整组合【包括组合名、商品、选择数量】！');
      // 	return
      // };
      setTimeout(function () {
        _this.$refs[form].validate(function (valid) {
          if (!valid) return;
          _this.loading = true;
          mealListApi[_this.ruleForm.id ? 'UpdateArticle' : 'AddArticle'](_objectSpread(_objectSpread({}, _this.ruleForm), {}, {
            image: _this.mealImg,
            comboInfoList: meatLists
          })).then(function (data) {
            _this.$message.success('操作成功');
            _this.loading = false;
            _this.goReturn();
          }).catch(function () {
            _this.loading = false;
          });
        });
      }, 10);
    }),
    // 获取详情
    getSpecDetail: function getSpecDetail(id) {
      var _this2 = this;
      this.ruleForm = {};
      mealListApi.getComDetail(id).then(function () {
        var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var _res$comboInfoList = res.comboInfoList,
          comboInfoList = _res$comboInfoList === void 0 ? [] : _res$comboInfoList;
        _this2.ruleForm = res;
        _this2.mealImg = res.image;
        _this2.details = _objectSpread(_objectSpread({}, res), {}, {
          comboInfoList: comboInfoList.length && comboInfoList.map(function (item) {
            var _ref3 = item || {},
              comboName = _ref3.comboName,
              max = _ref3.max,
              _ref3$skuList = _ref3.skuList,
              skuList = _ref3$skuList === void 0 ? [] : _ref3$skuList,
              id = _ref3.id,
              sort = _ref3.sort,
              image = _ref3.image;
            return {
              comboName: comboName,
              selectNum: max ? Number(max) : null,
              selectProduct: skuList,
              id: id,
              sort: sort,
              image: image
            };
          })
        });
      });
    },
    // 返回列表
    goReturn: function goReturn() {
      this.$router.push('/applet/mealList');
    },
    selectCompany: function selectCompany(companyId) {
      this.ruleForm = _objectSpread(_objectSpread({}, this.ruleForm), {}, {
        companyId: companyId
      });
    },
    //上传图片
    modalPicTap: function modalPicTap(tit, dataIndex) {
      var _this3 = this;
      this.$modalUpload(function (img) {
        _this3.mealImg = img[0].sattDir;
      }, tit, 'system');
    },
    removeImg: function removeImg() {
      this.mealImg = '';
    }
  }
};